import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import NoItemResult from '../../../../components/results/NoItemResult';
import { EditMode } from './type';

export type VehicleAssignmentsEmptyProps = { setEditMode: (value: EditMode) => void };

const VehicleAssignmentsEmpty = ({ setEditMode }: VehicleAssignmentsEmptyProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <NoItemResult
            extra={
                <Button onClick={() => setEditMode(EditMode.Vehicles)} type="primary">
                    {t('eventApplicationModuleDetails:actions.updateVehicleAssignments')}
                </Button>
            }
            subTitle={t('eventApplicationModuleDetails:tabs.vehicles.noData')}
        />
    );
};

export default VehicleAssignmentsEmpty;
